// Deterministic color from a string id — used to color-code technicians on calendar.
const PALETTE = [
  "#1FB6C1", // hidroverse teal
  "#F59E0B", // amber
  "#A78BFA", // violet
  "#10B981", // emerald
  "#F43F5E", // rose
  "#3B82F6", // blue
  "#EAB308", // yellow
  "#EC4899", // pink
  "#14B8A6", // teal2
  "#F97316", // orange
];

// Wave 22 — light-mode aware palette. The dark-mode palette uses bright/saturated
// hexes that wash out on white surfaces. Each entry is the "-700" / "-800" cousin
// that passes WCAG AA on white. Used for technician color chips on Calendar etc.
const PALETTE_LIGHT = [
  "#0d6e75", // teal -700
  "#b45309", // amber -700
  "#5b21b6", // violet -800
  "#047857", // emerald -700
  "#be123c", // rose -700
  "#1d4ed8", // blue -700
  "#854d0e", // yellow -800
  "#9d174d", // pink -800
  "#0f766e", // teal2 -700
  "#9a3412", // orange -800
];

function isLightTheme() {
  if (typeof document === "undefined") return false;
  return document.documentElement.getAttribute("data-theme") === "light";
}

export function colorFor(id) {
  if (!id) return isLightTheme() ? "#0a0b0e" : "#647087";
  let hash = 0;
  for (let i = 0; i < id.length; i++) hash = (hash << 5) - hash + id.charCodeAt(i);
  const idx = Math.abs(hash) % PALETTE.length;
  return (isLightTheme() ? PALETTE_LIGHT : PALETTE)[idx];
}

export function hexToRgba(hex, alpha = 1) {
  const h = hex.replace("#", "");
  const r = parseInt(h.substring(0, 2), 16);
  const g = parseInt(h.substring(2, 4), 16);
  const b = parseInt(h.substring(4, 6), 16);
  return `rgba(${r},${g},${b},${alpha})`;
}

